module.exports = __webpack_public_path__ + "static/img/friendly.b9930da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/friendly.png
// module id = fmr6
// module chunks = 1